import { render, staticRenderFns } from "./SolidRingChatForResult.vue?vue&type=template&id=6efef18c&scoped=true"
import script from "./SolidRingChatForResult.vue?vue&type=script&lang=js"
export * from "./SolidRingChatForResult.vue?vue&type=script&lang=js"
import style0 from "./SolidRingChatForResult.vue?vue&type=style&index=0&id=6efef18c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efef18c",
  null
  
)

export default component.exports